import { useState } from "react"
import Markdown from "react-markdown"

import { Textarea } from "@/components/ui/text-area"
import { cn } from "@/lib/utils"

interface MarkdownInputProps {
  id?: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
  minRows?: number
}

export function MarkdownInput({
  id,
  value,
  onChange,
  placeholder,
  className,
  minRows = 6,
}: MarkdownInputProps) {
  const [mode, setMode] = useState<"write" | "preview">("write")

  return (
    <div className={cn("w-full min-w-0 space-y-2", className)}>
      <div className="flex gap-1">
        <button
          type="button"
          className={cn(
            "rounded-md px-3 py-1 text-sm font-medium transition-colors",
            mode === "write"
              ? "bg-muted text-foreground"
              : "text-muted-foreground hover:text-foreground",
          )}
          onClick={() => setMode("write")}
        >
          Write
        </button>
        <button
          type="button"
          className={cn(
            "rounded-md px-3 py-1 text-sm font-medium transition-colors",
            mode === "preview"
              ? "bg-muted text-foreground"
              : "text-muted-foreground hover:text-foreground",
          )}
          onClick={() => setMode("preview")}
        >
          Preview
        </button>
      </div>

      {mode === "write" ? (
        <Textarea
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows={minRows}
          className="min-h-[150px]"
        />
      ) : (
        <div className="border-input min-h-[150px] rounded-md border px-3 py-2">
          {value ? (
            <div className="prose prose-sm dark:prose-invert max-w-none">
              <Markdown>{value}</Markdown>
            </div>
          ) : (
            <p className="text-muted-foreground text-sm">
              {placeholder ?? "Nothing to preview"}
            </p>
          )}
        </div>
      )}
    </div>
  )
}
